import { Component, ViewChild, ElementRef, OnInit, Renderer2, RendererFactory2 } from '@angular/core';
import { NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileHandle } from 'app/directives/dragDrop.directive';
import { UserGalleryService } from './user-gallery.service';
import { GlobalService } from 'app/global/global.service';
import { Branding, Gallery, ImageType, UserGalaryItems, UserGalleryList } from './user-galary.dto';
import { IPageableResponse } from 'app/global/pagging.dto';
import { TranslocoService } from '@jsverse/transloco';
import { IBrandingDto } from '../../settings/branding/branding.dto';

@Component({
  selector: 'app-user-gallery',
  templateUrl: './user-gallery.component.html',
  styleUrl: './user-gallery.component.scss'
})

export class UserGalleryComponent implements OnInit{
  @ViewChild('fileUpload') fileUpload:ElementRef;
  constructor(
    public activeModal: NgbActiveModal,
    public userGalleryService: UserGalleryService,
    public globalService: GlobalService,
    private translocoService: TranslocoService,
    private rendererFactory2: RendererFactory2
  ) {
    this.render2 = rendererFactory2.createRenderer(null, null);
  }
  private render2:Renderer2;
  public imageModalRef: NgbModalRef;
  public images:UserGalaryItems[];
  public activeImage: number = -1;
  public selectedImage: Gallery;
  public loadView: boolean = true;
  public files: FileHandle[] = [];
  public activatedNav: number = 1;
  public pagination: IPageableResponse<UserGalaryItems>;
  public page: number = 1;
  public brandingLogos: Branding[] = [];
  /**
   * directive file dropped
   * @param files 
   */
  filesDropped(files: FileHandle[]): void {
    this.uploadFile(files[0].file);
  }

  ngOnInit() {
    this.getGallery();
  }

  /**
   * get the user uploaded images
   * @param page 
   */
  getGallery(page: number = 1){
    this.userGalleryService.getUserGallery(page).subscribe({
      next : (images:UserGalleryList) => {
        this.images = images.user_gallery.data || [];
        this.pagination = images.user_gallery;
        this.brandingLogos = this.mapBrandingLogos(images.branding);
      },
      error: (err) => {this.globalService.toastrError(err);}
    });
  }

  /**
 * select the image
 * @param image 
 * @param index 
 */
  selectImage(image:Gallery, index) {
    this.selectedImage = image;
    this.activeImage = index;
  }

  /**
   * emit the image ref when add image
   */
  addImage() {
    this.activeModal.close({ selectedImage: null, status: 'done', image:this.selectedImage?.image, image_type: (this.selectedImage?.image_type || ImageType.UserImage) });
  }

  /**
   * on file change event
   * @param pFileList 
   */
  onFileChange(pFileList: File[]) {
    this.uploadFile(pFileList[0]);
  }

  /**
   * upload a image when drag and drop or browse
   * @param file 
   */
  uploadFile(file:File[][0]){
  if(!["image/png", "image/gif", "image/jpeg", "image/jpg"].includes(file.type)){
    this.globalService.toastrWarning(this.translocoService.translate("Image gallery toaster warning message - (Template/Document - section) - Only image type is allowed"));
    return;
  }
  const uploaderLoader = document.querySelector('.upload-pdf-loader');
  this.render2.removeClass(uploaderLoader, 'hidden');
   const formData: FormData = this.userGalleryService.collectFormData(file);
    this.userGalleryService.uploadImage(formData).subscribe({
        next: () => {
          this.fileUpload.nativeElement.value = '';
          this.render2.addClass(uploaderLoader, 'hidden');
          this.activatedNav = 2;
          this.ngOnInit();  
        },
        error: (err) => {
          this.fileUpload.nativeElement.value = '';
          this.globalService.toastrError(err);
          this.render2.addClass(uploaderLoader, 'hidden');
        }
      });
  }

  /**
   * Delete image from gallery
   * @param id 
   */
  deleteImage(id:number){
    this.images = this.images.filter((image:UserGalaryItems) => image.id != id);
    this.userGalleryService.deleteImage(id).subscribe(() => {});
  }

  /**
 * Extract branding logos safely
 */
  private mapBrandingLogos(branding?: IBrandingDto): Branding[] {
    if (!branding) return [];
    return [
      { id: branding.id, image: branding.logo, image_type: ImageType.BrandingLogo },
      { id: branding.id, image: branding.secondary_logo, image_type: ImageType.BrandingSecondaryLogo }
    ].filter(logo => logo.image);
  }

}